<div class="policy-page">
  <div class="policy-page__title">{{ 'components.policy.labels.title' | translate }}</div>

  <div class="policy-page__links">
    <!-- Документы из конфигурации -->
    <app-config-documents *ngIf="pageName" [pageName]="pageName" [showPolicyLink]="true"></app-config-documents>

    <!-- Политика конфиденциальности Яндекс (для SmartCaptcha) -->
    <app-download-link
      *ngIf="enterType === EnterType.Email && !isCordova"
      class="download-link"
      [fileLink]="captchaPolicyLink"
      [isLocalFile]="false"
    >
      {{ 'components.policy.buttons.yandex' | translate }}
    </app-download-link>
  </div>

  <button tuiButton type="button" class="policy-page__button-close" size="m" (click)="closePage()">
    {{ 'common.buttons.close' | translate }}
  </button>
</div>
